import type { BlockBidCsvKind } from '~/models/bidCsvHeader'
import { WORKFLOW_ID_PARAM } from '~/models/workflowIdParam'
import { routePaths } from '~/routes/routePaths'

/** CSV 取込画面 (`/bidding/spot/csv-import`) の種別。 ブロックは行の列構成の案内に使う `blockType` を持つ。 */
export type SpotCsvImportTarget =
  | { kind: 'normal' }
  | { kind: 'block'; blockType: BlockBidCsvKind }

/**
 * スポット入札画面から CSV 取込画面 (子ページ) へ遷移する URL。 ワークフロー経由で開いている間は、
 * CSV 確定にケースを載せ、 戻り先も読み取り専用のままにするため workflowId を引き継ぐ
 * (AC-BSP-079 / AC-WFW-014)。
 */
export function buildSpotCsvImportPath(
  target: SpotCsvImportTarget,
  workflowId: string | undefined,
): string {
  const params = new URLSearchParams({ kind: target.kind })
  if (target.kind === 'block') {
    params.set('blockType', target.blockType)
  }
  if (workflowId !== undefined) {
    params.set(WORKFLOW_ID_PARAM, workflowId)
  }
  return `${routePaths.biddingSpotCsvImport.path}?${params.toString()}`
}
